var _excluded = ["className", "children", "as", "isSelected", "disabled"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
/* eslint-disable id-length */
import classNamesMaker from "classnames";
import styles from "./TagCTA.module.css";

/**
 * The types of the props that are used in the TagCTA component
 */

/**
 * The type of all the props of the TagCTA component
 */

/**
 * The 2 types of the TagCTA component
 */

// eslint-disable-next-line react/function-component-definition
export function TagCTA(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    children = _ref.children,
    as = _ref.as,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    restProps = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var CustomTag = as || "button";
  var customClassNames = classNamesMaker(styles["jds-Tag"], styles["jds-Tag--cta"], isSelected && styles["jds-Tag--ctaSelected"], disabled && styles["jds-Tag--disabled"], className);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(CustomTag, _extends({
      className: customClassNames,
      disabled: disabled
    }, restProps), children)
  );
}